"use strict";

exports.__esModule = true;
exports.FieldError = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFinalForm = require("react-final-form");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ErrorSpan = _styledComponents["default"].span.withConfig({
  displayName: "FieldError__ErrorSpan",
  componentId: "sc-q6xq0b-0"
})(["color:", ";font-size:", ";"], (0, _Theme.val)("FormErrorColor"), (0, _Theme.val)("fontSizeXS"));
var FieldError = exports.FieldError = /*#__PURE__*/function (_Component) {
  function FieldError() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(FieldError, _Component);
  var _proto = FieldError.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      name = _this$props.name,
      touched = _this$props.touched;
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
      name: name,
      subscription: {
        error: true
      },
      render: function render(_ref) {
        var error = _ref.meta.error;
        return touched && error ? /*#__PURE__*/_react["default"].createElement(ErrorSpan, null, error) : null;
      }
    });
  };
  return FieldError;
}(_react.Component);